import {
  ADD_COMPONENT_EXPORT_CSV,
  ADD_COMPONENT_TO_PDF_EXPORT,
  CLEAR_CSV_EXPORT,
  CLEAR_PDF_EXPORT,
  SET_PDF_ANALYSIS_DATE,
  CLEAR_PDF_ANALYSIS_DATE,
  REMOVE_COMPONENT_FROM_PDF_EXPORT,
  REMOVE_COMPONENT_FROM_CSV_EXPORT,
  PdfExportsAction,
} from '../../types/redux/pdfExports/exportTypes';
import { FileExportStore } from '../../types/redux/pdfExports/FileExportsStore';

export default function FileExportReducer(
  state: FileExportStore = {
    componentsToExport: [],
    componentsToExportCSV: [],
    loadingPagePdf: false,
    analysisDate: undefined,
  },
  action: PdfExportsAction,
) {
  switch (action.type) {
    case CLEAR_PDF_EXPORT:
      return {
        ...state,
        componentsToExport: [],
      };
    case ADD_COMPONENT_TO_PDF_EXPORT:
      const currentComponents = state.componentsToExport.filter(
        (comp) => comp.identifier !== action.payload.identifier,
      );
      return {
        ...state,
        componentsToExport: [...currentComponents, action.payload],
      };
    case REMOVE_COMPONENT_FROM_PDF_EXPORT:
      return {
        ...state,
        componentsToExport: state.componentsToExport.filter(
          (comp) => comp.identifier !== action.payload,
        ),
      };

    case CLEAR_CSV_EXPORT:
      return {
        ...state,
        componentsToExportCSV: [],
      };
    case ADD_COMPONENT_EXPORT_CSV:
      const currentCSVComponents = state.componentsToExportCSV.filter(
        (comp) => comp.fileName !== action.payload.fileName,
      );
      return {
        ...state,
        componentsToExportCSV: [...currentCSVComponents, action.payload],
      };
    case REMOVE_COMPONENT_FROM_CSV_EXPORT:
      return {
        ...state,
        componentsToExportCSV: state.componentsToExportCSV.filter(
          (comp) => comp.fileName !== action.payload,
        ),
      };
    case SET_PDF_ANALYSIS_DATE:
      return {
        ...state,
        analysisDate: action.payload,
      };
    case CLEAR_PDF_ANALYSIS_DATE:
      return {
        ...state,
        analysisDate: undefined,
      };
    default:
      return state;
  }
}
